import { render, staticRenderFns } from "./OtherPageOpen.vue?vue&type=template&id=01778fed&scoped=true&"
import script from "./OtherPageOpen.vue?vue&type=script&lang=ts&"
export * from "./OtherPageOpen.vue?vue&type=script&lang=ts&"
import style0 from "./OtherPageOpen.vue?vue&type=style&index=0&id=01778fed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01778fed",
  null
  
)

export default component.exports